import { usePoll } from "@/lib/api";
import ControlBar from "@/components/ControlBar";
import LiveStatus from "@/components/LiveStatus";
import TriggerPanel from "@/components/TriggerPanel";
import SettingsPanel from "@/components/SettingsPanel";
import { Reports, AuditLog, EventLog } from "@/components/Reports";

export default function Dashboard() {
  const { data: s, err } = usePoll("/state", 1000);
  const { data: rep } = usePoll("/reports", 5000);
  const { data: tr } = usePoll("/trades?limit=200", 5000);
  const { data: trg } = usePoll("/triggers", 5000);
  if (!s) {
    return <div data-testid="dashboard-loading" className="p-10 text-[var(--text-dim)]">{err ? `Cannot reach the bot: ${err}` : "Loading Estuary…"}</div>;
  }
  return (
    <main data-testid="dashboard" className="max-w-[1400px] mx-auto px-4 md:px-8 pb-16 space-y-8">
      <ControlBar s={s} />
      {!s.credentials && <div data-testid="no-credentials" className="rounded border border-red-700 p-3 text-sm text-red-300">Kalshi keys are missing: the bot cannot trade.</div>}
      <LiveStatus s={s} />
      <TriggerPanel d={trg} config={s.config} />
      <SettingsPanel config={s.config} />
      <Reports r={rep} />
      <AuditLog trades={tr?.trades} />
      <EventLog logs={s.logs} />
    </main>
  );
}
